export default {
    onClick: actions => {
        actions.resolve();
    },
    showPayButton: true,
    enableStoreDetails: false,
    storePaymentMethod: false
};
